import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch } from 'react-redux';

import { getRouteStackPath } from '@portal/config/routes';
import { LoanStatus } from '@portal/models/enumerators/loans';
import { translate } from '@portal/services/i18n';
import { moneyFormat } from '@portal/utils/format';
import { LoanActions } from '@portal/actions';
import { useNavigation } from '@portal/hooks/useNavigation';

export interface LoansProps {
  loans: bank.Loan[];
}

const Loans = ({ loans }: LoansProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const handleStatusClick = (loan: bank.Loan) => {
    if (loan.status === LoanStatus.REQUESTED_WARRANTY) {
      dispatch(LoanActions.setLoan(loan));
      navigate(getRouteStackPath('LOAN', 'SIMULATE'), {
        state: { onlyWarranty: true },
      });
    }
  };

  return (
    <table className="loans">
      <thead className="loans__header">
        <tr>
          <td>
            <p>{translate('PAGES.LOAN.LOAN_PAGE.TABLE.DATE')}</p>
          </td>
          <td>
            <p>{translate('PAGES.LOAN.LOAN_PAGE.TABLE.AMOUNT')}</p>
          </td>
          <td>
            <p>{translate('PAGES.LOAN.LOAN_PAGE.TABLE.INSTALLMENTS')}</p>
          </td>
          <td>
            <p>{translate('PAGES.LOAN.LOAN_PAGE.TABLE.STATUS')}</p>
          </td>
        </tr>
      </thead>
      <tbody>
        {loans.map((loan) => (
          <tr className="loans__loan" key={loan.id}>
            <td>
              <p className="loans__loan__cell">
                {DateTime.fromISO(loan.contractStartDate).toFormat(
                  translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON')
                )}
              </p>
            </td>
            <td>
              <p className="loans__loan__cell">{moneyFormat(loan.amount)}</p>
            </td>
            <td>
              <p className="loans__loan__cell">{loan.installments}</p>
            </td>
            <td onClick={() => handleStatusClick(loan)}>
              <p
                className={`loans__loan__cell
                loans__loan__cell--status
                loans__loan__cell--status--${LoanStatus[loan.status]
                  .toLowerCase()
                  .replace(/_/g, '-')}`}
              >
                {translate(
                  `PAGES.LOAN.LOAN_PAGE.STATUS.${LoanStatus[loan.status]}`
                )}
              </p>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Loans;
